<template>
  <div class="login-card">
    <div class="login-card_content">
      <div class="login-card_header">
        <a href="https://www.parcelex.com.br/" class="login-card_header_brand" title="Parcelex">
          <img alt="Logo Parcelex" src="https://cdn.parcelex.com.br/assets/v2/website/parcelex-logo-color-dark.svg">
        </a>
      </div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default ({
  name: 'LoginBaseCard',
});
</script>

<style lang="scss" scoped>
  *, *::before, *::after {
    box-sizing: border-box;
  }

  .login-card {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    background-color: white;
    width: -webkit-fill-available;
    max-width: 28rem;
    border-radius: 1.5rem;
    box-shadow: var(--shadow-elevation-high);

    &_content {
      contain: content;
      padding: 2.25rem;

      @media (max-width: 1000px) {
        padding: 1.5rem;
      }
    }

    &_header {
        height: 2rem;
    }

    &_brand {
        display: inline-block;
        line-height: 2rem;
    }
  }

</style>
